import { useState } from 'react';

export default function QuoteSection() {
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <>
      <section id="quote" className="relative w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/7455c6c7e49181bdad2ed4b44e4d279c/e3a8c07f9b3ac74abbb850223c8bda9e.jpeg"
            alt="견적 문의"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/45 to-black/55"></div>
        </div>

        <div className="relative flex flex-col justify-between px-6 py-12 md:px-20 md:py-24 gap-8 md:gap-0 min-h-[300px] md:min-h-[560px]">
          <div className="max-w-2xl">
            <p className="text-orange-400 text-xs font-semibold uppercase tracking-widest mb-3 md:mb-4">Quick Quote</p>
            <h2 className="text-2xl md:text-6xl font-bold text-white leading-tight">
              빠르고 정확한<br />
              맞춤 견적 서비스
            </h2>
            <p className="text-white/75 text-sm md:text-lg font-light mt-3 md:mt-5 leading-relaxed">
              소재·두께·수량을 알려주시면 당일 내 검토 후 회신드립니다
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-5 md:gap-0">
            <button
              onClick={() => setShowContactModal(true)}
              className="group flex items-center gap-3 bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 md:px-8 md:py-4 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-lg"
            >
              <span className="text-sm md:text-base font-semibold">견적 문의하기</span>
              <div className="w-8 h-8 md:w-9 md:h-9 bg-white rounded-full flex items-center justify-center">
                <i className="ri-arrow-right-line text-orange-500 text-base md:text-lg"></i>
              </div>
            </button>

            <div className="text-left md:text-right space-y-1.5">
              <p className="text-white text-sm md:text-base font-light mb-2">AM 08:00 ~ PM 18:00</p>
              <div className="flex items-center justify-start md:justify-end gap-2 text-white/90 text-xs md:text-sm">
                <i className="ri-building-line text-sm"></i>
                <span className="font-semibold">NS-TECH</span>
              </div>
              <div className="flex items-center justify-start md:justify-end gap-2 text-white/75 text-xs md:text-sm">
                <i className="ri-phone-line text-sm"></i>
                <span>031-541-1902</span>
              </div>
              <div className="flex items-center justify-start md:justify-end gap-2 text-white/75 text-xs md:text-sm">
                <i className="ri-printer-line text-sm"></i>
                <span>031-541-1903</span>
              </div>
              <div className="flex items-center justify-start md:justify-end gap-2 text-white/75 text-xs md:text-sm">
                <i className="ri-mail-line text-sm"></i>
                <a href="mailto:nstech01@naver.com" className="hover:text-white transition-colors">nstech01@naver.com</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 연락처 모달 */}
      {showContactModal && (
        <div
          className="fixed inset-0 bg-black/60 z-50 flex items-end md:items-center justify-center p-0 md:p-4"
          onClick={() => setShowContactModal(false)}
        >
          <div
            className="bg-white rounded-t-3xl md:rounded-3xl max-w-md w-full p-6 md:p-8 relative shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowContactModal(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-gray-600 text-xl"></i>
            </button>

            <div className="text-center mb-6">
              <div className="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-customer-service-2-line text-orange-500 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-1">견적 문의</h3>
              <p className="text-xs text-gray-500">편하신 방법으로 연락주세요</p>
            </div>

            <div className="space-y-3 mb-6">
              {[
                { icon: 'ri-building-line', label: '회사명', value: 'NS-TECH' },
                { icon: 'ri-phone-line', label: '전화번호', value: '031-541-1902' },
                { icon: 'ri-printer-line', label: '팩스', value: '031-541-1903' },
                { icon: 'ri-mail-line', label: '이메일', value: 'nstech01@naver.com' },
                { icon: 'ri-time-line', label: '운영시간', value: 'AM 08:00 ~ PM 18:00' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3 p-3.5 bg-gray-50 rounded-xl">
                  <div className="w-9 h-9 bg-orange-100 rounded-full flex items-center justify-center shrink-0">
                    <i className={`${item.icon} text-orange-500 text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400">{item.label}</p>
                    <p className="text-sm font-semibold text-gray-900">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-2 gap-3">
              <a
                href="tel:031-541-1902"
                className="flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-xl font-medium transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-phone-line"></i>
                <span>전화하기</span>
              </a>
              <a
                href="mailto:nstech01@naver.com"
                className="flex items-center justify-center gap-2 bg-gray-900 hover:bg-gray-800 text-white py-3 rounded-xl font-medium transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-mail-line"></i>
                <span>메일보내기</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
